import apiClient from '@u/apiClient'
import GetSquareUpAuthLinkController from '@/wayfinder/actions/App/Http/Controllers/SquareUp/GetSquareUpAuthLinkController'
import GetSquareUpAuthStatusController from '@/wayfinder/actions/App/Http/Controllers/SquareUp/GetSquareUpAuthStatusController'

export default {
  getSquareUpAuthLink({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(GetSquareUpAuthLinkController.get({ company: payload.id }))
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  getSquareUpAuthStatus({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(GetSquareUpAuthStatusController.get({ company: payload.id }))
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  }
}
